export function getField(fieldPath, object, defaultValue) {
    const fields = fieldPath.split('.');
    let tmpObject = object;
    fields.forEach(v => {
        tmpObject = tmpObject[v];
    });
    return tmpObject || defaultValue;
}
//# sourceMappingURL=getField.js.map